import { setWorkspaceDirtyLabels } from './workspaceDirtyRegistry';

export const setActiveSeasonDirtyLabels = (labels: string[]): void => { setWorkspaceDirtyLabels('season', labels); };
